<nz-modal
        [(nzVisible)]="isVisible"
        [nzOkLoading]="submitLoading"
        [nzMaskClosable]="false"
        (nzOnCancel)="close()"
        (nzOnOk)="onSubmit()"
        nzWidth="700px"
        [nzTitle]="'Add Link to task'"
        nzOkText="OK"
        nzCancelText="Cancel"
>
    <div *nzModalContent>
        <form nz-form nzLayout="vertical" [formGroup]="validateForm" [nzAutoTips]="autoTips" class="form-container">
            <nz-form-item>
                <nz-form-control>
                    <nz-select
                            [nzDropdownRender]="renderTemplate"
                            nzShowSearch
                            nzAllowClear
                            nzMode="multiple"
                            formControlName="taskIds"
                            (nzScrollToBottom)="loadTask()"
                            [nzLoading]="taskLoading"
                            (nzOnSearch)="searchLinkTask($event)"
                            nzPlaceHolder="Select a linked task"
                    >
                        <ng-container *ngFor="let option of loadTaskOptions">
                            <!-- 只能加禁用，因为如果是过滤掉的话，每一层的分页个数如果少了就无法触底加载了 -->
                            <nz-option
                                    [nzValue]="option.taskId"
                                    [nzLabel]="option.taskName"
                                    [nzDisabled]="linkedTasksIds.includes(option.taskId) || option.taskId === taskDetail.taskId"
                            ></nz-option>
                        </ng-container>
                        <nz-option *ngIf="taskLoading && loadTaskOptions.length === 0" nzDisabled nzCustomContent>
                            <i nz-icon nzType="loading" class="loading-icon"></i>
                            Loading Data...
                        </nz-option>
                    </nz-select>
                    <ng-template #renderTemplate>
                        <nz-spin *ngIf="taskLoading && loadTaskOptions.length > 0"></nz-spin>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </form>
    </div>
</nz-modal>
